import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { AiFillCheckCircle } from 'react-icons/ai';
import { HiOutlineDownload } from "react-icons/hi";
import { MdRadioButtonUnchecked } from 'react-icons/md';
import { FiTrash2, FiEdit } from "react-icons/fi";
import { TbLoader } from "react-icons/tb";

import { HiOutlineExclamationTriangle } from "react-icons/hi2";


import Swal from "sweetalert2";
import ModalEIR from "./ModalContenedor/ModalEIR";
import ModalDemoras from "./ModalContenedor/ModalDemoras";
import ModalNaviera from "./ModalContenedor/ModalNaviera";
import ModalAgregarContenedor from "./ModalContenedor/ModalAgregarContenedor";
import ModalDemoraAnticipada from "./ModalContenedor/ModalDemoraAnticipada";
import ModalAgregarMultiContenedores from "./ModalContenedor/ModalAgregarMultiContenedores";
import {
  getAllContainers,
  getOneContainer,
  deleteOneContainer,
  BASE_URL
} from "../../../../helpers/Api";
import ListOptionsEstatus from "../../../../helpers/ListOptionsEstatus";
import {ModalAgregarBL} from "./ModalParsearBL/ModalParsearBL";
import {isDemorasAnticipadas} from "../../../../tools";
import {AGENTE_ADUANAL_USER} from "../../../../constants";
import ModalMultiDemoras from "./ModalContenedor/ModalMultiDemoras";
import ModalMultiEIR from "./ModalContenedor/ModalMultiEIR";
import ModalMultiCNaviera from "./ModalContenedor/ModalMultiCNaviera";
import ModalMultiTodo from "./ModalContenedor/ModalMultiTodo";

const Contenedores = ({solicitud, naviera}) => {

  const params = useParams();
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  const [loading, setLoading] = useState(true);
  const [dataOneContainer, setDataOneContainer] = useState('')
  const [containersData, setContainersData] = useState([]);
  const [idContenedor, setIdContenedor] = useState('');
  const [dataEir, setDataEir] = useState('');
  const [solicitudesPendientes, setSolicitudesPendientes] = useState(0);

  //MODALS
  const [modalAddContenedoresIsOpen, setModalAddContendoresIsOpen] = useState(false);
  const [modalAddBL, setModalAddBL] = useState(false);
  const [modalEirIsOpen, setModalEirIsOpen] = useState(false);
  const [modalDemoraAnticipadaIsOpen, setDemoraAnticipadaIsOpen] = useState(false);
  const [modalDemorasIsOpen, setModalDemorasIsOpen] = useState(false);
  const [modalNavieraIsOpen, setModalNavieraIsOpen] = useState(false);
  const [modalAddContainer, setModalAddContainer] = useState(false);
  const [modalMultiEIR, setModalMultiEIR] = useState(false);
  const [modalMultiCDemoras, setModalMultiCDemoras] = useState(false);
  const [modalMultiCNaviera, setModalMultiCNaviera] = useState(false);
  const [modalMultiTodo, setModalMultiTodo] = useState(false);
  //SEARCH
  const [containerNumber, setContainerNumber] = useState('');
  const [containerStatus, setContainerStatus] = useState('');

  //pagination
  const itemsPerPage = 10;
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

 //Multiple containers modal
  const openAddBLModal = () => {
    setModalAddBL(true);
  };
  const openAddContainersModal = () => {
    setModalAddContendoresIsOpen(true);
  };
  const closeAddContainersModal = () => {
    setModalAddContendoresIsOpen(false);
  };
  const closeAddBl = () => {
    setModalAddBL(false);
  };
  //

  const openAddMultiEIR = () => {
    setModalMultiEIR(true);
  }

  const closeAddMultiEIR = () => {
    setModalMultiEIR(false);
  }
  const openAddMultiCDemoras = () => {
    setModalMultiCDemoras(true);
  };
  const closeAddMultiCDemoras = () => {
    setModalMultiCDemoras(false);
  }
  const openAddMultiCNaviera = () => {
    setModalMultiCNaviera(true);
  }

  const closeAddMultiCNaviera = () => {
    setModalMultiCNaviera(false);
  }
  const openAddMultiTodo = () => {
    setModalMultiTodo(true);
  }
  const closeAddMultiTodo = () => {
    setModalMultiTodo(false);
  }
  const openAddContainerModal = () => {
    setModalAddContainer(true);
  };
  const closeAddContainerModal = () => {
    setModalAddContainer(false);
    setDataOneContainer([]);
  };

  const openDemoraAnticipadaModal = () => {
    setDemoraAnticipadaIsOpen(true);
  };
  const closeDemoraAnticipadaModal = () => {
    setDemoraAnticipadaIsOpen(false);
  };

  const openEirModal = () => {
    setModalEirIsOpen(true);
  };
  const closeEirModal = () => {
    setModalEirIsOpen(false);
  };

  const openDemorasModal = () => {
    setModalDemorasIsOpen(true);
  };
  const closeDemorasModal = () => {
    setModalDemorasIsOpen(false);
  };

  const openNavieraModal = () => {
    setModalNavieraIsOpen(true);
  };
  const closeNavieraModal = () => {
    setModalNavieraIsOpen(false);
  };

 
  useEffect(() => {
    getContainers()
  }, [
    containerNumber,
    containerStatus,
    modalDemoraAnticipadaIsOpen,
    modalEirIsOpen, 
    modalDemorasIsOpen, 
    modalAddContainer,
    modalNavieraIsOpen,
    modalAddContenedoresIsOpen,
    itemOffset,
  ])


  const getContainers = async () => {
    try {
      const response = await getAllContainers(
      itemsPerPage,
      itemOffset, 
      params.id, 
      containerNumber, 
      containerStatus,
      token,
      );
      if (response) {
        response?.count === itemsPerPage
        ? setPageCount(1)
        : setPageCount(Math.ceil(response?.count / itemsPerPage));
          setContainersData(response?.results);
          setSolicitudesPendientes(response?.count);
      }
    } catch (error) {
      throw error
    } finally {
      setLoading(false);
    }
  };

  const handlerGetOneContainer = async (idContenedor) => {
    try {
      const response = await getOneContainer(
        params.id, 
        idContenedor, 
        token);
      if (response) {
        setDataOneContainer(response);
        openAddContainerModal();
      }
    } catch (error) {
      throw error;
    }
  };


  const handlerDeleteContainer = async (idContenedor) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Una vez eliminado, no podrás recuperar este contenedor",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, eliminar!",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await deleteOneContainer(params.id, idContenedor, token);
          if (!response) {
            Swal.fire("Exito", "El contenedor ha sido borrado exitosamente", "success");
            getContainers();
          }
        } catch (error) {
          Swal.fire(
            "Oops",
            "Ha surgido un problema al eliminar el contenedor",
            "error"
          );
        }
      }
    });
  };


  const demoraAnticipadaCompletion = (value) => {
    setDataEir(value)
    setIdContenedor(value.id);
    openDemoraAnticipadaModal();
};


  const eirCompletion = (value) => {
      setDataEir(value)
      setIdContenedor(value.id);
      openEirModal();
  };

  const corteDemorasCompletion = (value) => {
    setDataEir(value)
    setIdContenedor(value.id);
    openDemorasModal();
};

    const navieraCompletion = (value) => {
    setDataEir(value)
    setIdContenedor(value.id);
    openNavieraModal();
  };

  const handlePageClick = (event) => {
    setItemOffset(event.selected * itemsPerPage);
  };

  const handlerContainerNumber = (e) => {
    setContainerNumber(e.target.value);
  };

  const handlerContainerStatus = (e) => {
    setContainerStatus(e === null ? '' : e.value);
  };


  const downLoadReporteContenedores = () => {
    fetch(`${BASE_URL}/generar-reporte-solicitud/${params.id}/`).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "reporte-listado-contenedores.xlsx";
        a.click();
      });
    });
  };



const alertaFullfillment = () =>{
  Swal.fire("Oops", `Es necesario subir un archivo previo antes de acompletar este paso`, "error");
}

  return (
    <>
      <ModalDemoraAnticipada
        token={token}
        idSolicitud={params.id}
        idContenedor={idContenedor} 
        modalDemoraAnticipadaIsOpen={modalDemoraAnticipadaIsOpen}
        closeDemoraAnticipadaModal={closeDemoraAnticipadaModal}
        dataEir={dataEir} 
      />
      <ModalMultiEIR
        idSolicitud={params.id}
        idContenedor={idContenedor}
        modalIsOpen={modalMultiEIR}
        closeModal={closeAddMultiEIR}
      />
      <ModalEIR
       token={token}
      idSolicitud={params.id}
      idContenedor={idContenedor} 
      modalIsOpen={modalEirIsOpen} 
      closeModal={closeEirModal}
      dataEir={dataEir} 
      />
      <ModalMultiDemoras
        token={token}
        idSolicitud={params.id}
        modalIsOpen={modalMultiCDemoras}
        closeModal={closeAddMultiCDemoras}
        dataEir={dataEir}
      />
      <ModalDemoras
      token={token}
      idSolicitud={params.id}
      idContenedor={idContenedor} 
      modalIsOpen={modalDemorasIsOpen} 
      closeModal={closeDemorasModal}
      dataEir={dataEir}  
      />
      <ModalNaviera
      token={token}
      idSolicitud={params.id}
      idContenedor={idContenedor} 
      modalIsOpen={modalNavieraIsOpen} 
      closeModal={closeNavieraModal} 
      dataEir={dataEir} 
      />
      <ModalMultiCNaviera
        idSolicitud={params.id}
        modalIsOpen={modalMultiCNaviera}
        closeModal={closeAddMultiCNaviera}
      />
      <ModalMultiTodo
        idSolicitud={params.id}
        modalIsOpen={modalMultiTodo}
        closeModal={closeAddMultiTodo}
      />
      <ModalAgregarContenedor 
      modalAddContainer={modalAddContainer} 
      closeAddContainerModal={closeAddContainerModal}
      dataOneContainer={dataOneContainer}
      naviera={naviera}
      />

      <ModalAgregarBL
        open={modalAddBL}
        close={closeAddBl}
        token={token}
        idSolicitud={params.id}
      />

      <ModalAgregarMultiContenedores
      token={token}
      idSolicitud={params.id}
      modalAddContenedoresIsOpen={modalAddContenedoresIsOpen}
      closeAddContainersModal={closeAddContainersModal}
      />
      { loading ? (
        <div className="d-flex justify-content-center" style={{marginTop: '4rem'}}>
              <TbLoader color={'rgb(10, 132, 254)'} className="loader" size={'3rem'}/>
          </div>
      ) : (
     <>
     <div className="row mb-4 mt-2">
      <div className="col-12 d-flex justify-content-end">
        {role === AGENTE_ADUANAL_USER &&
          <>
            <div className="btn-group" role="group" style={{marginRight: '10px'}}>
              <button type="button" className="btn stages_button  dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                Capturar etapas
              </button>
              <ul className="dropdown-menu">
                <li>
                  <label
                    onClick={() => {
                      openAddMultiEIR()
                    }}
                    className="dropdown-item" style={{marginTop: "0px"}}>
                    EIR
                  </label>
                </li>
                <li>
                  <label
                    onClick={() => {
                      openAddMultiCDemoras()
                    }}
                    className="dropdown-item" style={{marginTop: "0px"}}>
                    C. Demoras
                  </label>
                </li>
                <li>
                  <label
                    onClick={() => {
                      openAddMultiCNaviera()
                    }}
                    className="dropdown-item" style={{marginTop: "0px"}}>
                    C. Navieras
                  </label>
                </li>
                <li>
                  <label
                    onClick={() => {
                      openAddMultiTodo()
                    }}
                    className="dropdown-item" style={{marginTop: "0px"}}>
                    Proceso completo
                  </label>
                </li>
              </ul>
            </div>
            <button
              onClick={openAddContainerModal}
              className="btn principal_button" style={{marginRight: '10px'}}>
              + Agregar contenedor
            </button>
            {solicitud.naviera === "HAP" &&
            <button
              onClick={openAddBLModal}
              className="btn principal_button " style={{marginRight: '10px'}}>
              + Agregar BL
            </button>}
            <button
              onClick={openAddContainersModal}
              className="btn principal_button">
              + Agregar contenedores
            </button>

          </>
        }
        <button
          onClick={() => downLoadReporteContenedores()}
          className="btn download_button" style={{marginLeft: "10px"}}>
          <HiOutlineDownload size={"1.3rem"} style={{marginBottom: "1px"}}/>{" "}
          Contenedores
        </button>
      </div>
     </div>
       <div className="row mb-4 mt-2">
         <div className="col-3">
          <input
            className="form-control"
            type="search"
            onChange={handlerContainerNumber}
            value={containerNumber}
            placeholder="Número de contenedor"
            aria-label="Search"
            style={{ width: "100%" }}
          />
        </div>
        <div className="col-4">
        <Select
            className="basic-single"
            classNamePrefix="select"
            options={ListOptionsEstatus}
            onChange={(e) => handlerContainerStatus(e)}
            placeholder={"Filtro por estatus"}
            isClearable={true}  
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 table-responsive">
          <table className="table table_headers">
            <thead>
              <tr>
                <th scope="col">No. de contenedor</th>
                <th scope="col">Tipo de contenedor</th>
                <th scope="col">Días libres de demoras</th>
                <th scope="col">Días con demoras</th>
                <th scope="col">D.Anticipada</th>
                <th scope="col">EIR</th>
                <th scope="col">C.Demoras</th>
                <th scope="col">C.Naviera</th>
                <th scope="col">Acciones</th>
              </tr>
            </thead>
  
          { 
            containersData.length === 0 ?
            <>
            <td></td>
            <td></td>
            <td></td>
            <td><HiOutlineExclamationTriangle color="grey" /> Sin información cargada</td>
            <td></td>
            <td></td>
            </>
            :
            containersData?.map((value, index) =>{
              const demorasAnticipadas = isDemorasAnticipadas(solicitud, value)
              return <tbody key={index}>
              <tr>
                <td>{value.numero}</td>
                <td style={{ paddingTop: "14px" }}>{value.tipo_descripcion}</td>
                <td style={{ paddingTop: "14px" }}>{value.dias_libre_demora}</td>
                <td style={{ paddingTop: "14px" }}>{!value.dias_demoras ? '0' : value.dias_demoras}</td>
                
                { demorasAnticipadas ?
                <td style={{ paddingTop: "14px" }}>
                { (value.estado === "EIR") || (value.estado === "COR") || (value.estado === "CNA") || (value.estado === "TER") ?
                <button className="btn btn-light" onClick={() => demoraAnticipadaCompletion(value)}>
                  <AiFillCheckCircle color={'#9CD300'} size={'1.3rem'} />
                </button> 
                :
                <button className="btn btn-light" onClick={() => role === 'AGA' ? demoraAnticipadaCompletion(value) : null}>
                  <MdRadioButtonUnchecked  size={'1.3rem'} />
                </button> 
                }
                </td>: <td style={{ paddingTop: "14px" }}> </td>
                }

                { demorasAnticipadas && role === AGENTE_ADUANAL_USER ?
                <>
                <td style={{ paddingTop: "14px" }}>
                {
                (value.estado === "COR") || (value.estado === "CNA") || (value.estado === "TER") ?
                <button className="btn btn-light" onClick={() => eirCompletion(value)}>
                  <AiFillCheckCircle color={'#9CD300'} size={'1.3rem'} />
                </button> 
                :
                <button className="btn btn-light" onClick={() => !value.archivo_demoras_anticipadas ? alertaFullfillment() : eirCompletion(value)}>
                  <MdRadioButtonUnchecked  size={'1.3rem'} />
                </button> 
                }
                </td>
                </>
                :
                <>
                <td style={{ paddingTop: "14px" }}>
                {
                (value.estado === "COR") || (value.estado === "CNA") || (value.estado === "TER") ?
                <button className="btn btn-light" onClick={() => eirCompletion(value)}>
                  <AiFillCheckCircle color={'#9CD300'} size={'1.3rem'} />
                </button> 
                :
                <button className="btn btn-light" onClick={() => role === 'AGA' ? eirCompletion(value) : null}>
                  <MdRadioButtonUnchecked  size={'1.3rem'} />
                </button> 
                }
                </td>
                </>
                }

                <td style={{ paddingTop: "14px" }}>
                {(value.estado ===  "CNA") || (value.estado ===  "TER") ?
                <button className="btn btn-light" onClick={!value.corte_demoras_archivo ? null : () => corteDemorasCompletion(value) }>
                  <AiFillCheckCircle color={'#9CD300'} size={'1.3rem'} />
                </button> 
                :
               <button className="btn btn-light" onClick={value.estado === "PEN" ? () => role === 'AGA' ? alertaFullfillment() : null : () => role === 'AGA' ? corteDemorasCompletion(value) : null }>
                  <MdRadioButtonUnchecked  size={'1.3rem'} />
                </button> 
                }</td>
                <td style={{ paddingTop: "14px" }}>
                {value.estado ===  "TER" ?
                <button className="btn btn-light" onClick={()=> navieraCompletion(value) }>
                  <AiFillCheckCircle color={'#9CD300'} size={'1.3rem'} />
                </button> 
                :
                <button className="btn btn-light" onClick={(value.estado === "PEN") ||(value.estado === "COR") ? () => role === 'AGA' ? alertaFullfillment() : null : () =>  role === 'AGA' ? navieraCompletion(value) : null }>
                  <MdRadioButtonUnchecked  size={'1.3rem'} />
                </button> 
                } 
                </td>
                {role === 'ASC' &&
                <td style={{ paddingTop: "14px" }}>
                <FiTrash2 onClick={() => handlerDeleteContainer(value.id)} style={{ color: "#F34949", cursor: 'pointer' }} />
                </td>
                }
                {role === 'AGA'  &&
                <td style={{ paddingTop: "14px" }}>
                  {value.estado !==  "TER" &&
                    <FiEdit onClick={() => handlerGetOneContainer(value.id)} style={{ cursor: 'pointer' }} /> }
                </td>
                }
              </tr>
            </tbody>}
            )}
          </table>
        </div>
        <div className="row">
        <div className="col-12" style={{textAlign: 'center', marginTop: '2rem'}}>
            <p>Total de contenedores: {solicitudesPendientes}</p>
          </div>
          <div className="col-12 d-flex justify-content-end paginationList">
            <ReactPaginate
              breakLabel="..."
              nextLabel="Siguiente"
              onPageChange={handlePageClick}
              pageRangeDisplayed={10}
              pageCount={pageCount}
              previousLabel="Anterior"
              renderOnZeroPageCount={null}
              containerClassName="pagination my-5 mx-auto"
              subContainerClassName="pages pagination"
              activeClassName="active"
              breakClassName="break-me"
              className="pagination"
            />
          </div>
        </div>
      </div>
      </>
      )}
    </>
  );
};

export default Contenedores;
